import { buttonCssDefault } from './componentsDefaultCss'

export type EditableComponentUrls = {
	JSX: string
	SDK: string
	CSS: string
	npmModuleName: string
}

export type EditableCompsWhitelist = Record<string, EditableComponentUrls>

const editableCompsWhitelist: EditableCompsWhitelist = {
	// Button: {
	// 	JSX: 'https://6a30caff-5dc3-4e4c-ba70-19db988f5830.wixappcloud.com/browser/assets/script-asset-4190f51c-3836-49f6-8114-96219c165b29.ch.Bvj1HT8W.js',
	// 	SDK: '',
	// 	CSS: '',
	// 	npmModuleName: '@wix/editor-react-components/Button',
	// },
}

export const getAllCssImportMap = (): Record<string, string> => {
	const cssMap: Record<string, string> = {}

	Object.entries(editableCompsWhitelist).forEach(([_componentName, urls]) => {
		cssMap[urls.npmModuleName] = urls.CSS
	})

	return cssMap
}

export const getDefaultEditableCompsCss = () => {
	if (editableCompsWhitelist['Button']) {
		return buttonCssDefault
	}

	return ''
}

export const getBuilderComponentsDependencies = (): Record<string, string> => {
	const jsxMap: Record<string, string> = {}

	Object.entries(editableCompsWhitelist).forEach(([_componentName, urls]) => {
		jsxMap[urls.npmModuleName] = urls.JSX
	})

	return jsxMap
}

export const getAllSdkImportMap = (): Record<string, string> => {
	const sdkMap: Record<string, string> = {}

	Object.entries(editableCompsWhitelist).forEach(([_componentName, urls]) => {
		const moduleName = `${urls.npmModuleName}/sdk`
		sdkMap[moduleName] = urls.SDK
	})

	return sdkMap
}

export { editableCompsWhitelist }
